<template>
  <div
    :class="{
      'hals-and-tables-constructor-container': true,
      'grey-bg': !this.edit,
    }"
  >
    <div class="hals-and-tables-constructor-header mb-16"  v-if="!edit">
      <div class="left-header-part">
        <div class="header-label">
          {{ $t('tables_grid.heatmap') }}
        </div>
        <BaseSelect v-model="selected_section">
          <option v-for="(section,index) in cafe.sections" :value="index" :key="index">
            {{ section.name || (index+1) }}
          </option>
        </BaseSelect>
      </div>

      <!-- <DashboardButton v-if="edit" @click="addTable" variant="success-fill" icon="add-icon"
        >
        {{ $t('tables_grid.add_table') }}</DashboardButton
      > -->
      <div v-if="!edit" class="color-palete mb-16">
        <div class="color c1"></div>
        <div class="color c2"></div>
        <div class="color c3"></div>
        <div class="color c4"></div>
        <div class="color c5"></div>
      </div>
    </div>
    <div
      @mouseup="onGrabStopped"
      :class="`${move ? 'move' : resize ? 'resize' : ''}`"
      id="grid"
      class="hall-grid"
      @mouseleave="onGrabStopped"
      @mousemove="onGrabMoved"
    >
      <img
        src="/icons/hals-and-tables-constructor-bg.png"
        :class="{ img: true, opacity0: !edit }"
      />
      <img
        src="/icons/hals-and-tables-constructor-bg-vertical.png"
        :class="{ 'img-last': true, img: true, opacity0: !edit }"
      />
      <div
        @click="current_table = index"
        v-for="(table, index) in tables"
        :key="index"
        :style="`width:calc((100% / 56.99) * ${
          table.width
        });height:calc(100% / 36 * ${table.height});top:calc(100% / 36 * ${
          table.top
        });left:calc((100% / 57) *  ${table.left});z-index:${2};
          `"
        :class="`
          table ${table.width > 4 || table.height > 4 ? 'table-square' : ''} ${
          !edit ? 'c' + table.color : ''
        }
        `"
      >
        <div
          v-if="!edit && current_table == index"
          :class="{
            'selected-round': true,
            'border-radius-none': table.width != 4 || table.height != 4,
          }"
        ></div>
        <div
          :class="{ 'table-event-listener': true, 'cursor-pointer': !edit }"
          @mousedown.prevent="startGrabbing(index, 'move')"
        >
          <div class="table-text">{{ table.label }}</div>
        </div>
        <img
          v-if="edit"
          draggable="false"
          @mousedown="startGrabbing(index, 'resize')"
          src="/icons/black-threeangle.svg"
          class="resize-point"
        />
      </div>
    </div>
    <div v-if="!edit && currentTableItem" class="table-info-panel">
      <div class="table-info-title">{{ $t('halls_tables.table')}} {{currentTableItem.label}}</div>
      <div class="table-info-container">
        <div class="table-info-block">
          <div class="table-info-lable">
            {{ $t('tables_grid.avg_orders')}}
          </div>
          <div class="table-info-value">
            {{currentTableItem.orders_average}}
          </div>
        </div>
        <div class="table-info-block">
          <div class="table-info-lable">
            {{ $t('tables_grid.avg_sum')}}
          </div>
          <div class="table-info-value">
            {{currentTableItem.sum_average}}{{currency.symbol}}
          </div>
        </div>
        <div class="table-info-block">
          <div class="table-info-lable">
            {{ $t('tables_grid.avg_guests')}}
          </div>
          <div class="table-info-value">1</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BlackSelect from "@/components/BlackSelect.vue";
import DashboardButton from "@/components/DashboardButton.vue";

// const CELL_SIZE = 18.75;

const MAX_GRID_ROWS = 56;
const MAX_GRID_COLS = 56;

export default {
  props: {
    edit: {
      type: Boolean,
      default: true,
    },
    heatmap: Array,
    selected_section: { type: Number, default: 0 }
  },
  components: {
    BlackSelect,
    DashboardButton,
  },
  data() {
    return {
      move: false,
      resize: false,
      current_table: null,
      mouse_position: {
        top: null,
        left: null,
      },
      // selected_section: 0,

      grab_mode: 'move',
      grabbed_table_index: 0,
      grabbing: false,
      grab_delta_x: 0,
      grab_delta_y: 0
    };
  },
  methods: {
    startGrabbing(index, mode) {
      this.grab_mode = mode;
      this.grabbing = true;
      this.grabbed_table_index = index;
    },
    onGrabMoved(evt) {
      if(!this.grabbing) return;

      const grid = document.getElementById("grid");
      const CELL_SIZE = (grid.offsetWidth - 2) / MAX_GRID_COLS;

      this.grab_delta_x += evt.movementX;
      this.grab_delta_y += evt.movementY;

      let cells_x = 0;
      let cells_y = 0;

      if (Math.abs(this.grab_delta_x) > CELL_SIZE) {
        cells_x = Math.round(this.grab_delta_x / CELL_SIZE);

        this.grab_delta_x = 0;
      }

      if (Math.abs(this.grab_delta_y) > CELL_SIZE) {
        cells_y = Math.round(this.grab_delta_y / CELL_SIZE);

        this.grab_delta_y = 0;
      }

      const table = this.tables[this.grabbed_table_index];

      if (this.grab_mode == 'move') {
        const new_x = table.left + cells_x;
        const new_y = table.top + cells_y;

        if (new_x < 0 || new_x+table.width > MAX_GRID_COLS) return;
        if (new_y < 0 || new_y+table.height > MAX_GRID_ROWS) return;

        this.$store.commit('setTablePosition', {
          section_index: this.selected_section,
          table_index: this.grabbed_table_index,
          x_pos: new_x,
          y_pos: new_y
        });
      } else if (this.grab_mode == 'resize') {
        const new_width = table.width + cells_x;
        const new_height = table.height + cells_y;

        if (new_width < 4 || new_width-2 > MAX_GRID_COLS) return;
        if (new_height < 4|| new_height-2 > MAX_GRID_ROWS) return;

        this.$store.commit('setTableSize', {
          section_index: this.selected_section,
          table_index: this.grabbed_table_index,
          width: new_width,
          height: new_height
        });
      }

      // console.log(cells_x, cells_y);
    },
    onGrabStopped() {
      this.grabbing = false;

      this.$store.dispatch('saveCafe');
    },
    addTable() {
      this.$store.commit('addTable', {
        section_index: this.selected_section
      })
    },
    // handleEvent($event) {
    //   if (this.edit) {
    //     if (this.move) this.moving($event);
    //     else this.resizing($event);
    //   }
    // },
    // setMousePosition(index, $event, move, resize) {
    //   if (this.edit) {
    //     $event.preventDefault();
    //     this.mouse_position.top = $event.clientY;
    //     this.mouse_position.left = $event.clientX;
    //     this.current_table = index;
    //     this.move = move;
    //     this.resize = resize;
    //   }
    // },
    // resizing($event) {
    //   $event.preventDefault();
    //   let grid = document.getElementById("grid");
    //   let cell_width = (grid.offsetWidth - 2) / 56;
    //   let mouse_top = this.mouse_position.top - $event.clientY;
    //   let mouse_left = this.mouse_position.left - $event.clientX;
    //   if (mouse_top < 0) {
    //     let cels_to_add_count = Math.trunc(mouse_top / cell_width) * -1;
    //     this.tables[this.current_table].height += cels_to_add_count;
    //   }
    //   if (mouse_left < 0) {
    //     let cels_to_add_count = Math.trunc(mouse_left / cell_width) * -1;
    //     this.tables[this.current_table].width += cels_to_add_count;
    //   }
    //   if (mouse_top > 0) {
    //     let cels_to_add_count = Math.trunc(mouse_top / cell_width);
    //     this.tables[this.current_table].height -= cels_to_add_count;
    //     if (this.tables[this.current_table].height < 4)
    //       this.tables[this.current_table].height = 4;
    //   }
    //   if (mouse_left > 0) {
    //     let cels_to_add_count = Math.trunc(mouse_left / cell_width);
    //     this.tables[this.current_table].width -= cels_to_add_count;
    //     if (this.tables[this.current_table].width < 4)
    //       this.tables[this.current_table].width = 4;
    //   }
    //   this.current_table = null;
    //   this.resize = false;
    // },
    // moving($event) {
    //   let grid = document.getElementById("grid");
    //   let cell_width = (grid.offsetWidth - 2) / 56;
    //   let mouse_top = this.mouse_position.top - $event.clientY;
    //   let mouse_left = this.mouse_position.left - $event.clientX;
    //   if (mouse_top < 0) {
    //     let cels_to_add_count = Math.trunc(mouse_top / cell_width) * -1;
    //     this.tables[this.current_table].top += cels_to_add_count;
    //     if (
    //       this.tables[this.current_table].top >
    //       36 - this.tables[this.current_table].height - 1
    //     ) {
    //       this.tables[this.current_table].top =
    //         36 - this.tables[this.current_table].height - 1;
    //     }
    //   }
    //   if (mouse_left < 0) {
    //     let cels_to_add_count = Math.trunc(mouse_left / cell_width) * -1;
    //     this.tables[this.current_table].left += cels_to_add_count;
    //     if (
    //       this.tables[this.current_table].left >
    //       56 - this.tables[this.current_table].width
    //     ) {
    //       this.tables[this.current_table].left =
    //         56 - this.tables[this.current_table].width;
    //     }
    //   }
    //   if (mouse_top > 0) {
    //     let cels_to_add_count = Math.trunc(mouse_top / cell_width);
    //     this.tables[this.current_table].top -= cels_to_add_count;
    //     if (this.tables[this.current_table].top < 1)
    //       this.tables[this.current_table].top = 1;
    //   }
    //   if (mouse_left > 0) {
    //     let cels_to_add_count = Math.trunc(mouse_left / cell_width);
    //     this.tables[this.current_table].left -= cels_to_add_count;
    //     if (this.tables[this.current_table].left < 1)
    //       this.tables[this.current_table].left = 1;
    //   }
    //   this.current_table = null;
    //   this.move = false;
    // },
    getTableName(section_index, table) {
      const section = this.cafe.sections[+section_index];

      if (!section) return table;

      const table_item = section.tables_list[+table - 1];

      if (table_item) return table_item.name || table;

      return table;
    },
  },
  computed: {
    heatmapTables() {
      if (!this.heatmap) return;

      const HEATMAP_COLUMNS = 10;
      const TABLE_SIZE = 4;

      return this.cafe.sections[this.selected_section].tables_list.map((t, i) => {
        const heat_entry = this.heatmap.find(en => {
          return `${en.section}` == `${this.selected_section}` && `${en.table}` == `${i+1}`;
        });

        return {
          width: t.width || TABLE_SIZE,
          height: t.height || TABLE_SIZE,
          label: t.name || (i+1),
          color: heat_entry ? heat_entry.heat_level : 1,
          // top: Math.floor(i / HEATMAP_COLUMNS) * TABLE_SIZE + 1,
          // left: (i % HEATMAP_COLUMNS) * (TABLE_SIZE + 1) + 1,
          top: t.y_pos,
          left: t.x_pos,
          orders_average: heat_entry ? heat_entry.orders_average : 0,
          sum_average: heat_entry ? heat_entry.sum_average: 0
        };
      });
    },

    tables() {
      if (this.edit) {
        return this.editTables;
      } else {
        return this.heatmapTables;
      }
    },

    editTables() {
      if (!this.edit) return [];

      return this.cafe.sections[this.selected_section].tables_list.map((t,idx) => {
        return {
          left: t.x_pos || 4,
          top: t.y_pos || 4,
          width: t.width || 4,
          height: t.height || 4,
          label: t.name || idx+1
        }
      });
    },

    cafe() {
      return this.$store.state.cafe;
    },

    currentTableItem() {
      if (this.current_table === null) return null;
      return this.tables[this.current_table];
    },

    currency() {
      return this.$store.state.currency;
    }
  },
};
</script>
<style scoped>

.hals-and-tables-constructor-container * {
  user-select: none;
}

.hals-and-tables-constructor-container {
  background: #ededed;
  /* margin-top: 3.33333vh; */
}
.grey-bg {
  background: #e5e5e5;
  padding: 2.2222vh;
}
.hals-and-tables-constructor-header {
  /* margin-bottom: 1.111111vh; */
  display: flex;
  justify-content: space-between;
}
.left-header-part {
  width: 50%;
  display: flex;
}
.max-content {
  width: max-content;
  min-width: 36%;
  background: #ededed;
}
.hall-grid {
  width: 100%;
  height: max-content;
  position: relative;
  border: 1px solid #908f8d;
}
.table {
  position: absolute;
  background: #129b81;
  border-radius: 50%;
}
.table-event-listener {
  width: 100%;
  height: 100%;
  z-index: 1;
  cursor: move;
  display: flex;
  align-items: center;
  justify-content: center;
}
.move {
  cursor: move;
}
.table-square {
  border-radius: 0;
}
.img {
  width: calc(100% + 2px);
  height: auto;
  margin-top: -1px;
  margin-left: -1px;
  margin-bottom: -1px;
  border-radius: 1.333vh;
}
.img-last {
  position: absolute;
  top: 0px;
  left: 0px;
}
.resize-point {
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: nwse-resize;
  z-index: 2;
}
.resize {
  cursor: nwse-resize;
}
.table-text {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #ededed;
}
.header-label {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #908f8d;
  margin-right: 2.2222vh;
}
.color-palete {
  display: flex;
}
.color {
  width: 6.444444444444445vh;
  height: 3.6666666666666665vh;
}
.c1 {
  background: #ffd2a8;
}
.c2 {
  background: #f9ad91;
}
.c3 {
  background: #f28377;
}
.c4 {
  background: #ec5b5e;
}
.c5 {
  background: #e2223b;
}
.opacity0 {
  opacity: 0;
}
.selected-round {
  border: 0.33333vh solid #1d1d1b;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  pointer-events: none;
}
.cursor-pointer {
  cursor: pointer !important;
}
.table-info-panel {
  background: #1d1d1b;
  border-radius: 0.8888888888888888vh;
  padding: 2.2222vh;
  margin-top: 2.222vh;
}
.table-info-title {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #ededed;
  margin-bottom: 1.1111vh;
}
.table-info-lable {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.table-info-value {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #ededed;
}
.table-info-container {
  display: flex;
  justify-content: space-between;
}
.table-info-block {
  width: 31.5%;
}
.border-radius-none {
  border-radius: 0;
  border: 0.33333vh solid #1d1d1b;
}
</style>
